import { createComponent } from '@mtfe/sweet';
import { common, dom } from '@mtfe/sweet-utils';
import TopPoi from '../PoiInfoB/script';
import tpl from './dom.html';
import style from './style.less';

const { createUniqueId } = common;
const domId = createUniqueId();

const renderTopPoiA = (props) => {
    const component = TopPoiA({ ...props });
    dom.$id(domId).outerHTML = component;
};

const TopPoiA = (props) => {
    const data = {
        domId,
        poiInfoB: TopPoi({
            ...props,
        }),
    };
    const events = {};
    const component = createComponent(tpl, { data, style }, events);

    return component;
};

export default TopPoiA;
export { renderTopPoiA };
